

function DescriptionContent() {
    return (
        <div className="flex flex-row-reverse justify-between mb-7">
            <p> : توضیحات</p>
            <textarea className="w-9/12 h-40 border border-slate-200 rounded text-right px-1 resizeNo" />
        </div>
    )
}
export default DescriptionContent;